import React from 'react';
import PropTypes from 'prop-types';
import { SubHeading, Box, Button, Text } from '@components/common';
import { ModalContainer } from '@containers/layout';

function CancelConfirm(props) {
  const {
    onCancel,
    onSubmit,
    title,
    description,
    cancelLabel,
    submitLabel,
    optionalDescription
  } = props;
  return (
    <ModalContainer>
      <SubHeading textAlign="center" fontWeight="bold" mt={4} mb={4}>
        {title || 'Cancel service?'}
      </SubHeading>
      <Text fontSize={1} mb={4}>
        {description || 'If you cancel now, this booking will be lost.'}
      </Text>
      {optionalDescription && (
        <Text fontSize={1} mb={4}>
          {optionalDescription}
        </Text>
      )}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Button onClick={onCancel} p={3} flex={1}>
          {cancelLabel || 'Back'}
        </Button>
        {onSubmit && (
          <Button variant="secondary" ml={4} p={3} flex={1} onClick={onSubmit}>
            {submitLabel || 'Yes, cancel'}
          </Button>
        )}
      </Box>
    </ModalContainer>
  );
}

CancelConfirm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cancelLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  optionalDescription: PropTypes.string
};

export default CancelConfirm;
